import React from 'react';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import classNames from 'classnames';

import { Typography } from '@material-ui/core';

import { LOCALES_OBJ } from 'constants/base';

import useStyles from './styles';

const CalendarGeneralRow = ({ rangeList, title, selectedDate }) => {
  const classes = useStyles();
  const [t, i18n] = useTranslation();

  const selectedLanguage = i18n.language;

  return (
    <div className={classes.generalRow}>
      <Typography variant="h2" className={classes.tableName}>
        {t(title)}
      </Typography>
      <div className={classes.columnWrapper}>
        {rangeList.map((item, index) => {
          const day = moment(item.day, 'dddd')
            .locale(LOCALES_OBJ[selectedLanguage])
            .format('dddd');
          const isSameDay = moment().isSame(item.date, 'day');
          const isSelectedDay = selectedDate
            ? moment(selectedDate).isSame(item.date, 'day')
            : false;
          return (
            <Typography
              key={index}
              variant="body1"
              className={classNames(classes.column, {
                [classes.sameDay]: isSameDay,
                [classes.selectedDay]: !isSameDay && isSelectedDay
              })}
            >
              {`${day} ${item.number}`}
            </Typography>
          );
        })}
      </div>
    </div>
  );
};

export default CalendarGeneralRow;
